import { render, staticRenderFns } from "./DeleteUsers.vue?vue&type=template&id=4d612522&scoped=true&"
import script from "./DeleteUsers.vue?vue&type=script&lang=js&"
export * from "./DeleteUsers.vue?vue&type=script&lang=js&"
import style0 from "./DeleteUsers.vue?vue&type=style&index=0&id=4d612522&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d612522",
  null
  
)

export default component.exports